
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/digital-forest",
      function () {
        return require("private-next-pages/digital-forest/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/digital-forest"])
      });
    }
  